import { ComponentProps } from 'react';

export function MotorcycleTwoToneMd({ ...props }: ComponentProps<'svg'>) {
    return (
        <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M8.50003 4H7.30806C6.11617 4 5.03732 4.70558 4.55959 5.79754L2.19673 11.1984C1.61863 12.5197 2.58674 14 4.02905 14L4.5 14.0001C6.70466 14.0258 8.48387 15.8067 8.48387 17.9998H10.5C10.5 17.6245 10.4653 17.2572 10.3988 16.901L10.4648 17H21.5C22.6046 17 23.5 16.1046 23.5 15C23.5 12.4537 22.1404 10.2249 20.1076 9H21.5V6H17C15.8954 6 15 6.89543 15 8H14.5V9.18751L14.0637 9.35112L14.5504 10.6489C14.7955 11.3026 14.3122 12 13.614 12H4.79355C4.43298 12 4.19095 11.6299 4.33547 11.2996L6.3919 6.59918C6.55115 6.23519 6.91076 6 7.30806 6H8.50003V4Z'
                fill='#23B4FF'
            />
            <path
                d='M8.5 3C7.94771 3 7.5 3.44772 7.5 4V6C7.5 6.55228 7.94772 7 8.5 7C9.05229 7 9.5 6.55228 9.5 6V4C9.5 3.44772 9.05229 3 8.5 3Z'
                fill='currentcolor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.5 15C6.15685 15 7.5 16.3431 7.5 18C7.5 19.6569 6.15685 21 4.5 21C2.84315 21 1.5 19.6569 1.5 18C1.5 16.3431 2.84315 15 4.5 15ZM5.5 18C5.5 17.4477 5.05228 17 4.5 17C3.94772 17 3.5 17.4477 3.5 18C3.5 18.5523 3.94772 19 4.5 19C5.05228 19 5.5 18.5523 5.5 18Z'
                fill='currentcolor'
            />
            <path
                d='M17.5 19C18.6046 19 19.5 18.1046 19.5 17H21.5C21.5 19.2091 19.7091 21 17.5 21C15.2909 21 13.5 19.2091 13.5 17H15.5C15.5 18.1046 16.3954 19 17.5 19Z'
                fill='currentcolor'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.5 5C22.0523 5 22.5 5.44772 22.5 6V9C22.5 9.55228 22.0523 10 21.5 10H15C14.4477 10 14 9.55228 14 9V8C14 6.34315 15.3431 5 17 5H21.5ZM20.5 8V7H17C16.4477 7 16 7.44772 16 8H20.5Z'
                fill='currentcolor'
            />
        </svg>
    );
}
